<div class="container mx-auto px-4">
  <div class="bg-white rounded-lg p-4">
    <div class="flex flex-col sm:flex-row gap-4 sm:gap-6 items-stretch sm:items-center">

      <!-- Barre de recherche (à gauche, prend l'espace disponible) -->
      <div class="order-1 sm:order-none flex-1 sm:max-w-xs">
        <div class="relative">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <input type="text" [(ngModel)]="searchQuery" [placeholder]="t('team.searchPlaceholder')" class="w-full h-11 pl-10 pr-4 border border-gray-300 rounded-lg
               focus:ring-2 focus:ring-orange-500 focus:border-orange-500
               outline-none transition text-sm bg-white">
        </div>
      </div>

      <!-- Filtre par rôle (au milieu sur desktop) -->
      <div class="order-2 sm:order-none">
        <div class="relative w-full sm:w-48">
          <select [(ngModel)]="selectedRole" class="w-full h-11 px-4 pr-10 bg-white border border-gray-300 rounded-lg
               text-sm appearance-none cursor-pointer
               focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500">
            <option *ngFor="let option of roleOptions()" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
          <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd" />
            </svg>
          </div>
        </div>
      </div>

      <!-- Bouton Nouveau membre (tout à droite, seul) -->
      <div class="order-3 sm:order-none ml-auto">
        <button (click)="openAddMemberModal()" class="h-11 px-5 bg-orange-500 hover:bg-orange-600 text-white rounded-lg
             flex items-center gap-2 text-sm font-medium transition-colors whitespace-nowrap">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.85714 9.14286H1.14286C0.819051 9.14286 0.547813 9.03314 0.329147 8.81371C0.11048 8.59429 0.000765845 8.32305 3.94088e-06 8C-0.000757964 7.67695 0.108956 7.40571 0.329147 7.18629C0.549337 6.96686 0.820575 6.85714 1.14286 6.85714H6.85714V1.14286C6.85714 0.819051 6.96686 0.547813 7.18629 0.329147C7.40571 0.11048 7.67695 0.000765845 8 3.94088e-06C8.32305 -0.000757964 8.59467 0.108956 8.81486 0.329147C9.03505 0.549337 9.14438 0.820575 9.14286 1.14286V6.85714H14.8571C15.1809 6.85714 15.4526 6.96686 15.672 7.18629C15.8914 7.40571 16.0008 7.67695 16 8C15.9992 8.32305 15.8895 8.59467 15.6709 8.81486C15.4522 9.03505 15.1809 9.14438 14.8571 9.14286H9.14286V14.8571C9.14286 15.1809 9.03314 15.4526 8.81371 15.672C8.59429 15.8914 8.32305 16.0008 8 16C7.67695 15.9992 7.40571 15.8895 7.18629 15.6709C6.96686 15.4522 6.85714 15.1809 6.85714 14.8571V9.14286Z"
              fill="white" />
          </svg>

          <span class="hidden sm:inline">{{ t('team.newMember') }}</span>
        </button>
      </div>

    </div>
  </div>
</div>


<!-- Message d'erreur -->
<div *ngIf="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg mb-4">
  <p>{{ error }}</p>
  <button (click)="refresh()" class="mt-2 px-4 py-2 bg-red-500 text-white rounded-lg
           hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500">
    {{ t('team.retry') }}
  </button>
</div>


<div class="container mx-auto px-4">
  <!-- Tableau d'équipe -->
  <div class="bg-white rounded-lg shadow-lg overflow-hidden">
    <!-- Container avec scroll horizontal pour mobile -->
    <div class="overflow-x-auto">
      <!-- En-tête du tableau -->
      <div class="grid grid-cols-5 gap-4 px-6 py-4 border-b bg-gray-50 min-w-[700px]">
        <div class="font-semibold text-gray-700">{{ t('team.name') }}</div>
        <div class="font-semibold text-gray-700">{{ t('team.role') }}</div>
        <div class="font-semibold text-gray-700">{{ t('team.phone') }}</div>
        <div class="font-semibold text-gray-700">{{ t('team.present') }}</div>
        <div class="font-semibold text-gray-700 text-center">{{ t('team.action') }}</div>
      </div>

      <!-- Loading indicator -->
      <div *ngIf="isLoading" class="px-6 py-8 text-center">
        <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
        <p class="mt-2 text-gray-600">{{ t('team.loading') }}</p>
      </div>

      <!-- Lignes du tableau -->
      <div *ngIf="!isLoading" class="min-h-[400px] min-w-[700px]">
        <div *ngFor="let member of filteredTeamMembers"
          class="grid grid-cols-5 gap-4 px-6 py-4 border-b items-center hover:bg-gray-50 transition-colors">

          <!-- Colonne Nom avec avatar -->
          <div class="flex items-center gap-3">
            <div class="relative w-10 h-10 flex-shrink-0">
              <div class="w-10 h-10 rounded-full overflow-hidden bg-gray-200">
                <img [src]="member.avatar" [alt]="member.name" class="w-full h-full object-cover"
                  (error)="$any($event.target).src = 'assets/images/av1.svg'">
              </div>
              <!-- Indicateur vert/rouge de présence -->
              <span [class]="getPresentIndicatorClass(member.present)"
                title="{{ getPresentText(member.present) }}"></span>
            </div>
            <span class="font-medium text-gray-900 truncate">{{ member.name }}</span>
          </div>

          <div class="text-gray-700">
            <span class="inline-block px-3 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full">
              {{ formatRole(member.role) }}
            </span>
          </div>

          <!-- Colonne Téléphone -->
          <div class="text-gray-700">
            <a [href]="'tel:' + member.telephone" class="hover:text-orange-600 hover:underline transition-colors">
              {{ member.telephone }}
            </a>
          </div>

          <!-- Colonne Présent (Oui/Non) -->
          <div class="text-gray-700">
            <span [class]="getPresentClass(member.present)">
              {{ getPresentText(member.present) }}
            </span>
          </div>

          <!-- Colonne Action -->
          <div class="flex justify-center gap-2">
            <button class="p-2 hover:bg-gray-100 rounded-lg transition-colors inline-flex items-center justify-center"
              [title]="'Voir ' + member.name" (click)="viewMember(member)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.0003 7.6718C13.8089 7.66579 15.5825 8.17028 17.1172 9.12727C18.6518 10.0843 19.8853 11.4549 20.6757 13.0816C19.0528 16.3964 15.738 18.4915 12.0003 18.4915C8.26263 18.4915 4.94788 16.3964 3.32493 13.0816C4.11537 11.4549 5.34883 10.0843 6.8835 9.12727C8.41816 8.17028 10.1917 7.66579 12.0003 7.6718ZM12.0003 5.70459C7.0823 5.70459 2.8823 8.76361 1.18066 13.0816C2.8823 17.3997 7.0823 20.4587 12.0003 20.4587C16.9184 20.4587 21.1184 17.3997 22.82 13.0816C21.1184 8.76361 16.9184 5.70459 12.0003 5.70459ZM12.0003 10.6226C12.6525 10.6226 13.278 10.8817 13.7391 11.3429C14.2003 11.804 14.4594 12.4295 14.4594 13.0816C14.4594 13.7338 14.2003 14.3593 13.7391 14.8204C13.278 15.2816 12.6525 15.5407 12.0003 15.5407C11.3482 15.5407 10.7227 15.2816 10.2615 14.8204C9.80039 14.3593 9.54132 13.7338 9.54132 13.0816C9.54132 12.4295 9.80039 11.804 10.2615 11.3429C10.7227 10.8817 11.3482 10.6226 12.0003 10.6226ZM12.0003 8.65541C9.56099 8.65541 7.57411 10.6423 7.57411 13.0816C7.57411 15.521 9.56099 17.5079 12.0003 17.5079C14.4397 17.5079 16.4266 15.521 16.4266 13.0816C16.4266 10.6423 14.4397 8.65541 12.0003 8.65541Z"
                  fill="#4B4848" />
              </svg>
            </button>
            <button class="p-2 hover:bg-blue-100 rounded-lg transition-colors inline-flex items-center justify-center"
              [title]="'Modifier ' + member.name" (click)="editMember(member)">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z" fill="#4B4848" />
              </svg>
            </button>
            <button class="p-2 hover:bg-red-100 rounded-lg transition-colors inline-flex items-center justify-center"
              [title]="'Supprimer ' + member.name" (click)="deleteMember(member)">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z" fill="#DC2626" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Message si aucun membre -->
        <div *ngIf="filteredTeamMembers.length === 0 && !isLoading" class="px-6 py-12 text-center text-gray-500">
          <svg class="w-16 h-16 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z">
            </path>
          </svg>
          <p class="text-lg font-medium">{{ t('team.noMembers') }}</p>
          <p class="mt-1 text-sm">{{ t('team.startAddingMembers') }}</p>
        </div>
      </div>
    </div> <!-- Fin overflow-x-auto -->

    <!-- Pagination -->
    <div class="px-6 py-4 flex items-center justify-between border-t bg-gray-50">
      <span class="text-sm text-gray-600">{{ getPaginationText() }}</span>
      <div class="flex items-center space-x-2">
        <!-- Bouton précédent -->
        <button *ngIf="hasPreviousPage()" (click)="previousPage()"
          class="px-4 py-2 rounded-lg hover:bg-gray-100 text-orange-500 font-medium flex items-center gap-2 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
          {{ t('team.previous') }}
        </button>

        <!-- Numéros de page -->
        <button *ngFor="let page of getPageNumbers()" (click)="goToPage(page)"
          [class]="page === currentPage ? 
            'w-10 h-10 rounded-lg bg-orange-500 text-white font-semibold flex items-center justify-center shadow-sm' : 
            'w-10 h-10 rounded-lg hover:bg-gray-100 text-gray-600 font-medium flex items-center justify-center transition-colors'">
          {{ page }}
        </button>

        <!-- Bouton suivant -->
        <button *ngIf="hasNextPage()" (click)="nextPage()"
          class="px-4 py-2 rounded-lg hover:bg-gray-100 text-orange-500 font-medium flex items-center gap-2 transition-colors">
          {{ t('team.next') }}
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ========== POPUP CONFIRMATION SUPPRESSION ========== -->
<div *ngIf="showDeleteConfirm"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]"
  (click)="!isDeleting && cancelDelete()">
  <div class="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 p-6 transform transition-all"
    (click)="$event.stopPropagation()">

    <!-- Icône -->
    <div class="flex justify-center mb-4">
      <div class="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
        <svg class="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z"/>
        </svg>
      </div>
    </div>

    <!-- Titre -->
    <h3 class="text-xl font-bold text-gray-900 text-center mb-2">
      {{ t('team.deleteTitle') }}
    </h3>

    <!-- Message -->
    <p class="text-gray-600 text-center mb-4">
      {{ t('team.deleteConfirmBefore') }}
      <span class="font-semibold text-gray-900">{{ memberToDelete?.name }}</span>
      {{ t('team.deleteConfirmAfter') }}
    </p>

    <!-- Erreur contrainte FK -->
    <div *ngIf="deleteError" class="mb-4 px-4 py-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
      <div class="flex items-start gap-2">
        <svg class="w-4 h-4 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        <span>{{ deleteError }}</span>
      </div>

      <!-- Option désactivation -->
      <button *ngIf="showDeactivateOption" (click)="deactivateMember()" [disabled]="isDeleting"
        class="mt-3 w-full px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
        <svg *ngIf="isDeleting" class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <svg *ngIf="!isDeleting" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/>
        </svg>
        {{ isDeleting ? t('team.deactivating') : t('team.deactivateInstead') }}
      </button>
    </div>

    <!-- Boutons -->
    <div class="flex gap-3">
      <button (click)="cancelDelete()" [disabled]="isDeleting"
        class="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed">
        {{ t('team.cancel') }}
      </button>
      <button (click)="confirmDelete()" [disabled]="isDeleting"
        class="flex-1 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors font-medium disabled:opacity-75 disabled:cursor-not-allowed flex items-center justify-center gap-2">
        <svg *ngIf="isDeleting && !showDeactivateOption" class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        {{ isDeleting && !showDeactivateOption ? t('team.deleting') : t('team.delete') }}
      </button>
    </div>
  </div>
</div>

<!-- ========== POPUP SUCCÈS SUPPRESSION / DÉSACTIVATION ========== -->
<div *ngIf="showDeleteSuccess"
  class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[9999]"
  (click)="closeDeleteSuccess()">
  <div class="bg-white rounded-xl shadow-2xl max-w-sm w-full mx-4 p-6 transform transition-all"
    (click)="$event.stopPropagation()">

    <!-- Icône succès (vert = supprimé, orange = désactivé) -->
    <div class="flex justify-center mb-4">
      <div [class]="deleteSuccessType === 'deleted' ? 'w-16 h-16 rounded-full bg-green-100 flex items-center justify-center' : 'w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center'">
        <svg *ngIf="deleteSuccessType === 'deleted'" class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/>
        </svg>
        <svg *ngIf="deleteSuccessType === 'deactivated'" class="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/>
        </svg>
      </div>
    </div>

    <!-- Titre -->
    <h3 class="text-xl font-bold text-gray-900 text-center mb-2">
      {{ deleteSuccessType === 'deleted' ? t('team.deleteSuccess') : t('team.deactivateSuccess') }}
    </h3>

    <!-- Message -->
    <p class="text-gray-500 text-center text-sm mb-6">
      <span class="font-semibold text-gray-800">{{ deletedMemberName }}</span>
      {{ deleteSuccessType === 'deleted' ? t('team.deleteSuccessMsg') : t('team.deactivateSuccessMsg') }}
    </p>

    <!-- Barre de progression auto-fermeture -->
    <div class="w-full bg-gray-100 rounded-full h-1 mb-5 overflow-hidden">
      <div [class]="deleteSuccessType === 'deleted' ? 'bg-green-500 h-1 rounded-full animate-[shrink_4s_linear_forwards]' : 'bg-orange-500 h-1 rounded-full animate-[shrink_4s_linear_forwards]'" style="width:100%"></div>
    </div>

    <!-- Bouton fermer -->
    <button (click)="closeDeleteSuccess()"
      [class]="deleteSuccessType === 'deleted' ? 'w-full px-4 py-2.5 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors font-medium' : 'w-full px-4 py-2.5 bg-orange-500 hover:bg-orange-600 text-white rounded-lg transition-colors font-medium'">
      {{ t('team.close') }}
    </button>
  </div>
</div>

<!-- Modal d'ajout de membre -->
<div *ngIf="showAddMemberModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
  (click)="onBackdropClick($event)">

  <div class="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
    <!-- Modal Header -->
    <div class="flex justify-between items-center p-6 border-b border-gray-200">
      <h2 class="text-xl font-semibold text-gray-800">{{ t('team.addNewMember') }}</h2>
      <button (click)="closeAddMemberModal()" class="text-gray-400 hover:text-gray-600 transition-colors">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="p-6 space-y-4">
      <!-- Messages d'erreur/succès -->
      <div *ngIf="submitError" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
        {{ submitError }}
      </div>

      <div *ngIf="submitSuccess" class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
        {{ submitSuccess }}
      </div>

      <!-- Formulaire d'ajout -->
      <form (ngSubmit)="submitAddMember()" #addMemberForm="ngForm">
        <!-- Nom et Prénom -->
        <div class="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label for="nom" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.lastName') }} *</label>
            <input type="text" id="nom" [(ngModel)]="newMember.nom" name="nom" required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              placeholder="Nom">
          </div>
          <div>
            <label for="prenom" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.firstName') }} *</label>
            <input type="text" id="prenom" [(ngModel)]="newMember.prenom" name="prenom" required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              placeholder="Prénom">
          </div>
        </div>

        <!-- Email et Téléphone -->
        <div class="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.email') }} *</label>
            <input type="email" id="email" [(ngModel)]="newMember.email" name="email" required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              placeholder="email@exemple.com">
          </div>
          <div>
            <label for="telephone" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.phone') }} *</label>
            <input type="tel" id="telephone" [(ngModel)]="newMember.telephone" name="telephone" required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              placeholder="77 123 45 67">
          </div>
        </div>

        <!-- Date de naissance et Lieu de naissance -->
        <div class="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label for="date" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.birthDate') }} *</label>
            <input type="date" id="date" [(ngModel)]="newMember.date" name="date" required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent">
          </div>
          <div>
            <label for="lieunaissance" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.birthPlace') }}
              *</label>
            <input type="text" id="lieunaissance" [(ngModel)]="newMember.lieunaissance" name="lieunaissance" required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              placeholder="Ville de naissance">
          </div>
        </div>

        <!-- Adresse -->
        <div class="mb-4">
          <label for="adress" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.address') }} *</label>
          <input type="text" id="adress" [(ngModel)]="newMember.adress" name="adress" required
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
            placeholder="Adresse complète">
        </div>

        <!-- Profil / Rôle -->
        <div class="mb-4">
          <label for="profil" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.profile') }} *</label>
          <div class="relative">
            <select id="profil" [(ngModel)]="newMember.profil" name="profil" required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent appearance-none cursor-pointer bg-white">
              <option value="WORKER">{{ t('team.profiles.worker') }}</option>
              <option value="SITE_MANAGER">{{ t('team.profiles.siteManager') }}</option>
              <option value="SUBCONTRACTOR">{{ t('team.profiles.subcontractor') }}</option>
              <option value="PROMOTEUR">{{ t('team.profiles.promoteur') }}</option>
            </select>
            <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd" />
              </svg>
            </div>
          </div>
        </div>
        <!-- Photo (optionnelle) -->
        <div class="mb-4">
          <label for="photo" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.profilePhoto') }}</label>

          <!-- Zone d'upload -->
          <div class="flex items-start gap-4">
            <!-- Aperçu de la photo -->
            <div *ngIf="photoPreview" class="flex-shrink-0">
              <div class="relative w-24 h-24 rounded-lg overflow-hidden border-2 border-gray-200">
                <img [src]="photoPreview" alt="Aperçu" class="w-full h-full object-cover">
                <button type="button" (click)="removePhoto()"
                  class="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                    </path>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Input file -->
            <div class="flex-1">
              <input type="file" id="photo" name="photo" accept="image/*" (change)="onPhotoSelected($event)"
                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent">
              <p class="mt-1 text-xs text-gray-500">{{ t('team.acceptedFormats') }}</p>
            </div>
          </div>
        </div>

        <!-- Mot de passe -->
        <div class="mb-6">
          <label for="password" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.password') }} *</label>
          <input type="password" id="password" [(ngModel)]="newMember.password" name="password" required minlength="6"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
            [placeholder]="t('team.passwordMinLength')">
        </div>

        <!-- Actions du formulaire -->
        <div class="flex justify-end gap-3 pt-4 border-t">
          <button type="button" (click)="closeAddMemberModal()"
            class="px-6 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
            {{ t('team.cancel') }}
          </button>
          <button type="submit" [disabled]="isSubmitting"
            class="px-6 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            <span *ngIf="isSubmitting" class="flex items-center gap-2">
              <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                </path>
              </svg>
              {{ t('team.adding') }}
            </span>
            <span *ngIf="!isSubmitting">{{ t('team.add') }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Modal d'édition de membre -->
<div *ngIf="showEditMemberModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
  (click)="onEditBackdropClick($event)">

  <div class="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
    <!-- Modal Header -->
    <div class="flex justify-between items-center p-6 border-b border-gray-200">
      <h2 class="text-xl font-semibold text-gray-800">{{ t('team.editMember') }}</h2>
      <button (click)="closeEditMemberModal()" class="text-gray-400 hover:text-gray-600 transition-colors">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="p-6 space-y-4">

      <!-- Chargement des données -->
      <div *ngIf="isLoadingEditData" class="flex flex-col items-center justify-center py-12 gap-3">
        <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-orange-500"></div>
        <p class="text-sm text-gray-500">{{ t('team.loadingData') }}</p>
      </div>

      <!-- Message d'erreur -->
      <div *ngIf="editError && !isLoadingEditData" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
        {{ editError }}
      </div>

      <!-- Formulaire d'édition -->
      <form *ngIf="!isLoadingEditData" (ngSubmit)="updateMember()" #editMemberForm="ngForm">
        <!-- Nom et Prénom -->
        <div class="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label for="edit-nom" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.lastName') }} *</label>
            <input type="text" id="edit-nom" [(ngModel)]="editingMember.nom" name="nom" required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              [placeholder]="t('team.lastName')">
          </div>
          <div>
            <label for="edit-prenom" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.firstName') }} *</label>
            <input type="text" id="edit-prenom" [(ngModel)]="editingMember.prenom" name="prenom" required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              [placeholder]="t('team.firstName')">
          </div>
        </div>

        <!-- Email et Téléphone -->
        <div class="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label for="edit-email" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.email') }} *</label>
            <input type="email" id="edit-email" [(ngModel)]="editingMember.email" name="email" required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              placeholder="email@exemple.com">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.phone') }}</label>
            <div class="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm text-gray-500 flex items-center gap-2">
              <svg class="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
              </svg>
              <span>{{ editingMember.telephone }}</span>
            </div>
            <p class="mt-1 text-xs text-gray-400">{{ t('team.phoneReadOnly') }}</p>
          </div>
        </div>

        <!-- Date de naissance et Lieu de naissance -->
        <div class="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label for="edit-dateOfBirth" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.birthDate') }}</label>
            <input type="date" id="edit-dateOfBirth" [(ngModel)]="editingMember.dateOfBirth" name="dateOfBirth"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent">
          </div>
          <div>
            <label for="edit-lieunaissance" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.birthPlace') }}</label>
            <input type="text" id="edit-lieunaissance" [(ngModel)]="editingMember.lieunaissance" name="lieunaissance"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              [placeholder]="t('team.birthPlace')">
          </div>
        </div>

        <!-- Adresse -->
        <div class="mb-4">
          <label for="edit-adress" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.address') }} *</label>
          <input type="text" id="edit-adress" [(ngModel)]="editingMember.adress" name="adress" required
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
            [placeholder]="t('team.address')">
        </div>

        <!-- Profil / Rôle -->
        <div class="mb-4">
          <label for="edit-profil" class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.profile') }} *</label>
          <div class="relative">
            <select id="edit-profil" [(ngModel)]="editingMember.role" name="role" required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent appearance-none cursor-pointer bg-white">
              <option value="WORKER">{{ t('team.profiles.worker') }}</option>
              <option value="SITE_MANAGER">{{ t('team.profiles.siteManager') }}</option>
              <option value="CHEF_CHANTIER">{{ t('team.roles.siteManager') }}</option>
              <option value="SUBCONTRACTOR">{{ t('team.profiles.subcontractor') }}</option>
              <option value="PROMOTEUR">{{ t('team.profiles.promoteur') }}</option>
              <option value="MAITRE_OEUVRE">{{ t('team.roles.masterBuilder') }}</option>
              <option value="MAITRE_OUVRAGE">{{ t('team.roles.projectOwner') }}</option>
              <option value="ARCHITECTE">{{ t('team.roles.architect') }}</option>
              <option value="INGENIEUR">{{ t('team.roles.engineer') }}</option>
            </select>
            <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd" />
              </svg>
            </div>
          </div>
        </div>

        <!-- Photo -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-2">{{ t('team.profilePhoto') }}</label>
          <div class="flex items-start gap-4">
            <!-- Aperçu photo actuelle ou nouvelle -->
            <div *ngIf="editPhotoPreview" class="flex-shrink-0">
              <div class="relative w-20 h-20 rounded-lg overflow-hidden border-2 border-gray-200">
                <img [src]="editPhotoPreview" alt="Photo" class="w-full h-full object-cover">
                <button type="button" (click)="removeEditPhoto()"
                  class="absolute top-1 right-1 bg-red-500 text-white rounded-full p-0.5 hover:bg-red-600 transition-colors">
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class="flex-1">
              <input type="file" id="edit-photo" name="editPhoto" accept="image/*"
                (change)="onEditPhotoSelected($event)"
                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm">
              <p class="mt-1 text-xs text-gray-500">{{ t('team.acceptedFormats') }}</p>
            </div>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="flex justify-end gap-3 pt-4 border-t border-gray-200">
          <button type="button" (click)="closeEditMemberModal()"
            class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors">
            {{ t('team.cancel') }}
          </button>
          <button type="submit" [disabled]="isEditing"
            class="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
            <span *ngIf="!isEditing">{{ t('team.save') }}</span>
            <span *ngIf="isEditing">{{ t('team.saving') }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Modal de visualisation du membre - Version améliorée -->
<div *ngIf="showViewModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
  (click)="onViewBackdropClick($event)">

  <div class="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
    <!-- Modal Header -->
    <div class="flex justify-between items-center p-6 border-b border-gray-200">
      <h2 class="text-xl font-semibold text-gray-800">{{ t('team.details') }}</h2>
      <button (click)="closeViewModal()" class="text-gray-400 hover:text-gray-600 transition-colors">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <!-- Modal de visualisation du membre -->

    <div *ngIf="showViewModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
      (click)="onViewBackdropClick($event)">

      <div class="bg-white rounded-lg shadow-xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
        <!-- Modal Header -->
        <div class="flex justify-between items-center px-6 py-4 border-b border-gray-200">
          <h2 class="text-xl font-semibold text-gray-900">{{ t('team.details') }}</h2>
          <button (click)="closeViewModal()" class="text-gray-400 hover:text-gray-600 transition-colors">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>

        <!-- Modal Content -->
        <div class="p-6" *ngIf="selectedMember">
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <!-- Colonne gauche - Informations principales -->
            <div class="space-y-4">
              <!-- Profil -->
              <div class="flex items-center gap-4 p-4 border border-gray-200 rounded-lg">
                <div class="relative w-14 h-14 flex-shrink-0">
                  <div class="w-14 h-14 rounded-full overflow-hidden bg-gray-200">
                    <img [src]="selectedMember.avatar" [alt]="selectedMember.name" class="w-full h-full object-cover">
                  </div>
                  <!-- Indicateur de présence sur la photo du modal -->
                  <span [class]="getPresentIndicatorClass(selectedMember.present)"
                    [title]="getPresentText(selectedMember.present)"></span>
                </div>
                <div class="flex-1">
                  <h3 class="text-base font-semibold text-gray-900">{{ selectedMember.name }}</h3>
                  <p class="text-sm text-gray-600">{{ formatRole(selectedMember.role) }}</p>
                  <!-- Badge présence sous le nom -->
                  <span [class]="getPresentClass(selectedMember.present)" class="mt-1 inline-block">
                    {{ getPresentText(selectedMember.present) }}
                  </span>
                </div>
                <div class="flex gap-2">
                  <button
                    class="w-10 h-10 rounded-full border border-gray-300 hover:bg-gray-50 flex items-center justify-center transition-colors">
                    <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z">
                      </path>
                    </svg>
                  </button>
                  <button
                    class="w-10 h-10 rounded-full border border-gray-300 hover:bg-gray-50 flex items-center justify-center transition-colors">
                    <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z">
                      </path>
                    </svg>
                  </button>
                </div>
              </div>

              <!-- Statistiques en grille 2x2 -->
              <div class="grid grid-cols-2 gap-4">
                <!-- Jours présents -->
                <div class="p-4 rounded-lg border border-gray-200 bg-white">
                  <p class="text-xs text-gray-600 mb-1">{{ t('team.daysPresent') }}</p>
                  <div class="flex items-end justify-between">
                    <p class="text-3xl font-bold text-gray-900">{{ selectedMember.daysPresent }}</p>
                    <div class="w-10 h-10 rounded-lg bg-orange-50 flex items-center justify-center flex-shrink-0">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12 1.5V0M15.7785 2.2035L16.3185 0.804M17.8335 3.2685L18.4605 3.723M20.5845 5.9535L21.8115 5.0895M21.7005 7.9815L23.394 8.2365M22.4955 11.742L23.997 11.7045M22.299 14.049L23.565 15.201M20.871 17.6175L22.138 18.42M19.425 19.425L20.4855 20.4855"
                          stroke="#F5A623" stroke-width="1.5" />
                        <path
                          d="M12 1.5C6.201 1.5 1.5 6.201 1.5 12C1.5 17.799 6.201 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12"
                          stroke="#F5A623" stroke-width="1.5" />
                        <path
                          d="M11.25 4.5C11.25 4.30109 11.329 4.11032 11.4697 3.96967C11.6103 3.82902 11.8011 3.75 12 3.75C12.1989 3.75 12.3897 3.82902 12.5303 3.96967C12.671 4.11032 12.75 4.30109 12.75 4.5V13.5L16.872 15.849C17.0397 15.9502 17.1612 16.1129 17.2104 16.3024C17.2597 16.492 17.2329 16.6933 17.1358 16.8633C17.0386 17.0333 16.8788 17.1586 16.6905 17.2124C16.5022 17.2661 16.3003 17.2441 16.128 17.151L11.25 14.628V4.5Z"
                          fill="#F5A623" />
                      </svg>
                    </div>
                  </div>
                </div>

                <!-- Heures travaillées -->
                <div class="p-4 rounded-lg border border-gray-200 bg-white">
                  <p class="text-xs text-gray-600 mb-1">{{ t('team.hoursWorked') }}</p>
                  <div class="flex items-end justify-between">
                    <p class="text-3xl font-bold text-gray-900">{{ selectedMember.hoursWorked }}</p>
                    <div class="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.825 21.75H17.175C18.103 21.75 18.841 20.986 18.741 20.107C18.096 14.438 14.25 14.531 14.25 12C14.25 9.469 18.146 9.609 18.74 3.893C18.834 3.013 18.102 2.25 17.174 2.25H6.825C5.897 2.25 5.167 3.013 5.259 3.893C5.854 9.609 9.75 9.422 9.75 12C9.75 14.578 5.903 14.438 5.259 20.107C5.159 20.986 5.897 21.75 6.825 21.75Z"
                          stroke="#4C6EF5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M16.092 20.25H7.928C7.197 20.25 6.991 19.406 7.504 18.883C8.745 17.625 11.25 16.724 11.25 15.281V10.5C11.25 9.57 9.469 8.859 8.367 7.35C8.185 7.101 8.203 6.75 8.666 6.75H15.356C15.75 6.75 15.836 7.098 15.656 7.348C14.57 8.859 12.75 9.565 12.75 10.5V15.281C12.75 16.712 15.362 17.484 16.519 18.884C16.985 19.449 16.822 20.25 16.092 20.25Z"
                          fill="#4C6EF5" />
                      </svg>
                    </div>
                  </div>
                </div>

                <!-- Tâches terminées -->
                <div class="p-4 rounded-lg border border-gray-200 bg-white">
                  <p class="text-xs text-gray-600 mb-1">{{ t('team.tasksCompleted') }}</p>
                  <div class="flex items-end justify-between">
                    <p class="text-3xl font-bold text-gray-900">{{ selectedMember.tasksCompleted }}</p>
                    <div class="w-10 h-10 rounded-lg bg-green-50 flex items-center justify-center flex-shrink-0">
                      <svg class="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                    </div>
                  </div>
                </div>

                <!-- Performance -->
                <div class="p-4 rounded-lg border border-gray-200 bg-white">
                  <p class="text-xs text-gray-600 mb-1">{{ t('team.performance') }}</p>
                  <div class="flex items-end justify-between">
                    <p class="text-3xl font-bold text-gray-900">{{ selectedMember.performance }}%</p>
                    <div class="w-10 h-10 rounded-lg bg-purple-50 flex items-center justify-center flex-shrink-0">
                      <svg class="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z">
                        </path>
                        <path
                          d="M22.875 5.25V11.25C22.875 11.548 22.756 11.834 22.545 12.045C22.334 12.256 22.048 12.375 21.75 12.375C21.452 12.375 21.165 12.256 20.954 12.045C20.744 11.834 20.625 11.548 20.625 11.25V7.969L13.546 15.049C13.337 15.257 13.056 15.374 12.763 15.374C12.47 15.374 12.189 15.257 11.98 15.049L9.028 12.094L3.074 18.046C2.863 18.257 2.576 18.376 2.277 18.376C1.978 18.376 1.691 18.257 1.48 18.046C1.269 17.835 1.15 17.548 1.15 17.249C1.15 16.95 1.269 16.664 1.48 16.452L8.23 9.702C8.439 9.494 8.72 9.377 9.013 9.377C9.306 9.377 9.587 9.494 9.796 9.702L12.75 12.656L19.031 6.375H15.75C15.452 6.375 15.165 6.256 14.954 6.045C14.744 5.834 14.625 5.548 14.625 5.25C14.625 4.952 14.744 4.665 14.954 4.454C15.165 4.244 15.452 4.125 15.75 4.125H21.75C22.048 4.125 22.334 4.244 22.545 4.454C22.756 4.665 22.875 4.952 22.875 5.25Z"
                          fill="#EF4444" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Répartition des tâches -->
              <div class="border border-gray-200 rounded-lg p-4 bg-white">
                <h4 class="text-sm font-semibold text-gray-900 mb-4">{{ t('team.taskDistribution') }} (%)</h4>
                <div class="flex items-center gap-8">
                  <!-- Donut Chart -->
                  <div class="relative w-32 h-32 flex-shrink-0">
                    <svg class="w-full h-full transform -rotate-90">
                      <circle cx="64" cy="64" r="52" fill="none" stroke="#e5e7eb" stroke-width="24"></circle>

                      <ng-container *ngIf="selectedMember.taskDistribution">
                        <!-- Terminées - vert -->
                        <circle *ngIf="(selectedMember.taskDistribution['Terminées'] || 0) > 0" cx="64" cy="64" r="52"
                          fill="none" stroke="#22c55e" stroke-width="24"
                          [attr.stroke-dasharray]="calculateStrokeDasharray(selectedMember.taskDistribution['Terminées'] || 0)"
                          [attr.stroke-dashoffset]="calculateStrokeDashoffset(getTaskOffsets()['Terminées'])">
                        </circle>

                        <!-- En Cours - orange -->
                        <circle *ngIf="(selectedMember.taskDistribution['En Cours'] || 0) > 0" cx="64" cy="64" r="52"
                          fill="none" stroke="#f97316" stroke-width="24"
                          [attr.stroke-dasharray]="calculateStrokeDasharray(selectedMember.taskDistribution['En Cours'] || 0)"
                          [attr.stroke-dashoffset]="calculateStrokeDashoffset(getTaskOffsets()['En Cours'])"></circle>

                        <!-- À Faire - gris clair -->
                        <circle *ngIf="(selectedMember.taskDistribution['À Faire'] || 0) > 0" cx="64" cy="64" r="52"
                          fill="none" stroke="#d1d5db" stroke-width="24"
                          [attr.stroke-dasharray]="calculateStrokeDasharray(selectedMember.taskDistribution['À Faire'] || 0)"
                          [attr.stroke-dashoffset]="calculateStrokeDashoffset(getTaskOffsets()['À Faire'])"></circle>

                        <!-- En Retard - rouge -->
                        <circle *ngIf="(selectedMember.taskDistribution['En Retard'] || 0) > 0" cx="64" cy="64" r="52"
                          fill="none" stroke="#ef4444" stroke-width="24"
                          [attr.stroke-dasharray]="calculateStrokeDasharray(selectedMember.taskDistribution['En Retard'] || 0)"
                          [attr.stroke-dashoffset]="calculateStrokeDashoffset(getTaskOffsets()['En Retard'])">
                        </circle>
                      </ng-container>
                    </svg>
                  </div>
                  <!-- Légende -->
                  <div class="space-y-2 flex-1">
                    <div class="flex items-center justify-between text-sm">
                      <div class="flex items-center gap-2">
                        <div class="w-3 h-3 rounded-full bg-gray-300"></div>
                        <span class="text-gray-700">{{ t('team.tasksTodo') }}</span>
                      </div>
                      <span class="font-semibold text-gray-900">{{ selectedMember.taskDistribution?.['À Faire'] || 0
                        }}%</span>
                    </div>
                    <div class="flex items-center justify-between text-sm">
                      <div class="flex items-center gap-2">
                        <div class="w-3 h-3 rounded-full bg-orange-500"></div>
                        <span class="text-gray-700">{{ t('team.tasksInProgress') }}</span>
                      </div>
                      <span class="font-semibold text-gray-900">{{ selectedMember.taskDistribution?.['En Cours'] || 0
                        }}%</span>
                    </div>
                    <div class="flex items-center justify-between text-sm">
                      <div class="flex items-center gap-2">
                        <div class="w-3 h-3 rounded-full bg-green-500"></div>
                        <span class="text-gray-700">{{ t('team.tasksDone') }}</span>
                      </div>
                      <span class="font-semibold text-gray-900">{{ selectedMember.taskDistribution?.['Terminées'] || 0
                        }}%</span>
                    </div>
                    <div class="flex items-center justify-between text-sm">
                      <div class="flex items-center gap-2">
                        <div class="w-3 h-3 rounded-full bg-red-500"></div>
                        <span class="text-gray-700">{{ t('team.tasksLate') }}</span>
                      </div>
                      <span class="font-semibold text-gray-900">{{ selectedMember.taskDistribution?.['En Retard'] || 0
                        }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Colonne droite - Historique des présences -->
            <div class="space-y-4">
              <div class="flex items-center justify-between mb-2">
                <h4 class="text-sm font-semibold text-gray-900">{{ t('team.presenceHistory') }}</h4>
                <div class="relative">
                  <button (click)="toggleDatePicker()"
                    class="text-sm text-gray-700 hover:text-gray-900 flex items-center gap-1.5 px-3 py-1.5 rounded border border-gray-300 hover:bg-gray-50 transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                      </path>
                    </svg>
                    {{ t('team.filterByDate') }}
                  </button>

                  <!-- Date Picker Popup -->
                  <div *ngIf="showDatePicker"
                    class="absolute right-0 top-full mt-2 bg-white rounded-lg shadow-xl border border-gray-200 p-4 z-50 w-80">
                    <div class="flex items-center justify-between mb-4">
                      <button (click)="previousMonth()" class="p-1 hover:bg-gray-100 rounded transition-colors">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7">
                          </path>
                        </svg>
                      </button>
                      <span class="font-semibold text-gray-900">{{ currentMonthYear }}</span>
                      <button (click)="nextMonth()" class="p-1 hover:bg-gray-100 rounded transition-colors">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7">
                          </path>
                        </svg>
                      </button>
                    </div>
                    <div class="grid grid-cols-7 gap-1">
                      <div class="text-center text-xs font-medium text-gray-600 py-2"
                        *ngFor="let day of ['team.mon', 'team.tue', 'team.wed', 'team.thu', 'team.fri', 'team.sat', 'team.sun']">{{ t(day) }}</div>
                      <!-- Empty cells for alignment -->
                      <div *ngFor="let empty of getEmptyDays()" class="text-center text-sm py-2"></div>
                      <!-- Calendar days -->
                      <div *ngFor="let day of getCalendarDays()" (click)="selectDate(day)" [class]="getDayClasses(day)"
                        class="text-center text-sm py-2 hover:bg-gray-100 rounded cursor-pointer transition-colors">
                        {{ day.getDate() }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Historique des présences : en-tête de date une seule fois par groupe -->
              <div class="space-y-4 max-h-[500px] overflow-y-auto pr-2"
                *ngIf="selectedMember.presenceHistory && selectedMember.presenceHistory.length > 0">
                <div *ngFor="let day of getFilteredPresenceHistory()" class="mb-4">

                  <!-- En-tête de date — affiché UNE SEULE FOIS par groupe -->
                  <div class="flex items-center justify-between mb-3 border-l-4 border-orange-500 pl-4 pb-1">
                    <span class="text-sm font-semibold text-gray-900">{{ day.date }}</span>
                    <span class="text-sm text-gray-600">{{ t('team.total') }}: {{ day.totalTime }}</span>
                  </div>

                  <!-- Cards d'entrée/sortie pour ce groupe de dates -->
                  <div *ngFor="let session of day.sessions" class="bg-white border border-gray-200 rounded-lg p-3 mb-2">
                    <div class="flex items-center gap-3 mb-2">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.5"
                          d="M6.5625 12.5625C8.1538 12.5625 9.67992 11.9304 10.8051 10.8051C11.9304 9.67992 12.5625 8.1538 12.5625 6.5625C12.5625 4.9712 11.9304 3.44508 10.8051 2.31986C9.67992 1.19464 8.1538 0.5625 6.5625 0.5625"
                          stroke="#1EA438" stroke-width="1.125" stroke-linecap="round" />
                        <path d="M0.5625 6.5625H8.0625M8.0625 6.5625L5.8125 4.3125M8.0625 6.5625L5.8125 8.8125"
                          stroke="#1EA438" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <div class="flex-1">
                        <span class="text-sm text-gray-600">{{ t('team.entry') }}:</span>
                        <span class="text-sm font-semibold text-gray-900 ml-1">{{ session.entry }}</span>
                      </div>
                      <span class="text-xs px-2.5 py-0.5 bg-green-100 text-green-700 rounded-full font-medium">{{
                        t('team.present') }}</span>
                    </div>
                    <div class="flex items-center gap-3">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.5"
                          d="M6.5625 0.5625C4.9712 0.5625 3.44508 1.19464 2.31986 2.31986C1.19464 3.44508 0.5625 4.9712 0.5625 6.5625C0.5625 8.1538 1.19464 9.67992 2.31986 10.8051C3.44508 11.9304 4.9712 12.5625 6.5625 12.5625"
                          stroke="#FF5C02" stroke-width="1.125" stroke-linecap="round" />
                        <path d="M12.5625 6.5625L5.0625 6.5625M5.0625 6.5625L7.3125 8.8125M5.0625 6.5625L7.3125 4.3125"
                          stroke="#FF5C02" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <div class="flex-1">
                        <span class="text-sm text-gray-600">{{ t('team.exit') }}:</span>
                        <span class="text-sm font-semibold text-gray-900 ml-1">{{ session.exit }}</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <!-- Message si pas d'historique -->
              <div *ngIf="!selectedMember.presenceHistory || selectedMember.presenceHistory.length === 0"
                class="text-center py-12 text-gray-500">
                <svg class="w-12 h-12 mx-auto mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
                <p class="text-sm">{{ t('team.noPresenceHistory') }}</p>
              </div>

              <!-- Total heures travaillées -->
              <div class="bg-gray-50 border border-gray-200 p-4 rounded-lg">
                <div class="flex items-center justify-between">
                  <span class="text-sm font-semibold text-gray-900">{{ t('team.totalHoursWorked') }}</span>
                  <span class="text-xl font-bold text-gray-900">{{ getTotalWorkedTime() }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Actions -->
          <div class="flex justify-start pt-6 border-t mt-6">
            <button type="button" (click)="closeViewModal()"
              class="px-6 py-2.5 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors font-medium">
              {{ t('team.close') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>